import { Modal, Button, Spinner } from "react-bootstrap";
import React from "react";
// import trash from "../../Assets/Images/trash.png";

//css
import "./Modal.css";
import { WarningOutlined } from "@ant-design/icons";

function ConfirmModal(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Body className="pb-4">
          <div className="row">
            <div className="col-12 align-wb-center py-3">
              {/* <img src={trash} width={50} height={50} /> */}
              <WarningOutlined
                style={{
                  fontSize: "300%",
                  color: "rgb(223, 9, 49)",
                  // backgroundColor: "#FFF8E1",
                  padding: 15,
                  borderRadius: "50%",
                }}
              />
            </div>
            <div className="col-12 align-wb-center">
              {props.message || "Are you sure?"}
            </div>

            <div className="col-12 align-wb-center font-xsmall">
              {props.caption || "This action cannot be undone."}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-sm-6">
              <Button
                size="sm"
                className="action-btn cancel-clear"
                style={{ width: "100%" }}
                onClick={props.onHide}
              >
                Cancel
              </Button>
            </div>
            <div className="col-sm-6">
              <Button
                size="sm"
                className="action-btn warning-cancel"
                style={{ width: "100%" }}
                onClick={props.onConfirm}
                disabled={props.loading}
              >
                {props.loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Confirming...
                  </>
                ) : (
                  "Confirm"
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ConfirmModal;
